import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'gob-class-page',
  templateUrl: './class-page.component.html',
  styleUrls: ['./class-page.component.css']
})
export class ClassPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
